import "core-js/modules/es6.string.small";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { EMPTY_PIXEL } from '~/const/images';
import { formatPrismicImage } from '~/helpers/image-helper';
import GlobalIntro from '~/components/molecules/Editorial/Global/GlobalIntro.vue';

var MediaAndOverlay = function MediaAndOverlay() {
  return import(
  /* webpackChunkName:"global-editorial" */
  '~/components/molecules/Global/MediaAndOverlay.vue');
};

var SPACING = {
  none: 'mt-O',
  small: 'mt-3',
  medium: 'mt-4',
  large: 'mt-double',
  negative: 'mt-negative-double'
};
export default {
  components: {
    GlobalIntro: GlobalIntro,
    // ElementMedia,
    MediaAndOverlay: MediaAndOverlay
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      mobile: true
    };
  },
  computed: {
    ratio: function ratio() {
      var _ref16;

      if (this.mobile) {
        return '4:3';
      }

      return ((_ref16 = this.payload) != null ? (_ref16 = _ref16.primary) != null ? _ref16.ratioimg : _ref16 : _ref16) || '';
    },
    currentPayload: function currentPayload() {
      var _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15;

      var small = formatPrismicImage((_ref15 = this.payload) != null ? (_ref15 = _ref15.primary) != null ? (_ref15 = _ref15.image) != null ? (_ref15 = _ref15.small) != null ? _ref15.url : _ref15 : _ref15 : _ref15 : _ref15, [['w_375', 'c_fill', "ar_".concat(this.ratio)]]) || '';
      var medium = formatPrismicImage((_ref14 = this.payload) != null ? (_ref14 = _ref14.primary) != null ? (_ref14 = _ref14.image) != null ? _ref14.url : _ref14 : _ref14 : _ref14, [['w_375', 'dpr_2', 'c_fill', "ar_".concat(this.ratio)]]) || EMPTY_PIXEL;
      var large = formatPrismicImage((_ref13 = this.payload) != null ? (_ref13 = _ref13.primary) != null ? (_ref13 = _ref13.image) != null ? (_ref13 = _ref13.large) != null ? _ref13.url : _ref13 : _ref13 : _ref13 : _ref13, [['w_1440', 'c_fill', "ar_".concat(this.ratio)]]) || EMPTY_PIXEL;
      var xlarge = formatPrismicImage((_ref12 = this.payload) != null ? (_ref12 = _ref12.primary) != null ? (_ref12 = _ref12.image) != null ? _ref12.url : _ref12 : _ref12 : _ref12, [['w_1440', 'dpr_2', 'c_fill', "ar_".concat(this.ratio)]]) || EMPTY_PIXEL;
      return {
        src: ((_ref11 = this.payload) != null ? (_ref11 = _ref11.primary) != null ? (_ref11 = _ref11.image) != null ? (_ref11 = _ref11.small) != null ? _ref11.url : _ref11 : _ref11 : _ref11 : _ref11) || '',
        srcset: "".concat(small, " 375w, ").concat(medium, " 750w, ").concat(large, " 1440w, ").concat(xlarge, " 2880w"),
        image: ((_ref10 = this.payload) != null ? (_ref10 = _ref10.primary) != null ? _ref10.image : _ref10 : _ref10) || null,
        alt: ((_ref9 = this.payload) != null ? (_ref9 = _ref9.primary) != null ? _ref9.alt : _ref9 : _ref9) || '',
        ratioImg: this.ratio,
        color: ((_ref8 = this.payload) != null ? (_ref8 = _ref8.primary) != null ? _ref8.color : _ref8 : _ref8) || '#3c3c3b',
        titleLevel: ((_ref7 = this.payload) != null ? (_ref7 = _ref7.primary) != null ? (_ref7 = _ref7.title) != null ? (_ref7 = _ref7[0]) != null ? _ref7.type : _ref7 : _ref7 : _ref7 : _ref7) || 'heading1',
        subtitleLevel: ((_ref6 = this.payload) != null ? (_ref6 = _ref6.primary) != null ? (_ref6 = _ref6.subtitle) != null ? (_ref6 = _ref6[0]) != null ? _ref6.type : _ref6 : _ref6 : _ref6 : _ref6) || 'heading2',
        videoMp4: formatPrismicImage((_ref5 = this.payload) != null ? (_ref5 = _ref5.primary) != null ? _ref5.videoMp4 : _ref5 : _ref5, [], '', 'video') || '',
        videoWebm: formatPrismicImage((_ref4 = this.payload) != null ? (_ref4 = _ref4.primary) != null ? _ref4.videoWebm : _ref4 : _ref4, [], '', 'video') || '',
        style: ((_ref3 = this.payload) != null ? (_ref3 = _ref3.primary) != null ? _ref3.style : _ref3 : _ref3) || 'primary',
        gradient: ((_ref2 = this.payload) != null ? (_ref2 = _ref2.primary) != null ? _ref2.gradient : _ref2 : _ref2) === 'Yes'
      };
    },
    builderTopSpacing: function builderTopSpacing() {
      var _ref;

      return SPACING[(_ref = this.payload) != null ? (_ref = _ref.primary) != null ? _ref.spacing : _ref : _ref];
    },
    introStyle: function introStyle() {
      return [{
        'position-relative': !this.hasMedia && this.currentPayload.style === 'primary'
      }, {
        'mx-auto': this.currentPayload.style === 'secondary'
      }, {
        'h-100': this.currentPayload.style === 'primary'
      }, {
        'justify-content-center': this.currentPayload.style === 'primary'
      }];
    },
    hasMedia: function hasMedia() {
      return Boolean(this.currentPayload.src && this.currentPayload.src.length > 0 || this.currentPayload.videoMp4 && this.currentPayload.videoMp4.length > 0 || this.currentPayload.videoWebm && this.currentPayload.videoWebm.length > 0);
    }
  },
  mounted: function mounted() {
    this.mobile = this.isMobile();
  }
};